import { memo } from 'react';
// Local files
import Item from './Item/Item';
import BaseAnalysesList from 'components/Analyses/Common/BaseAnalysesList/BaseAnalysesList';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useCustomSelector from 'hooks/useCustomSelector';
import useFirstAnalyses from 'hooks/useFirstAnalyses';
import { firstAnalysesSelectors } from "features/firstAnalyses";

const FirstAnalysesList = () => {
  const { getFirstAnalyses } = useFirstAnalyses();
  const { data, pagination } = useCustomSelector(firstAnalysesSelectors.getFirstAnalysesData);
  const fetching = useCustomSelector(firstAnalysesSelectors.firstAnalysesIsFetching);
  
  return (
    <BaseAnalysesList
      fetchData={getFirstAnalyses}
      getData={data}
      isFetching={fetching}
      pagination={pagination}
      renderItem={(item) => <Item key={item.id} {...item} />}
    />
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <FirstAnalysesList {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);